import { Injectable } from '@angular/core';

import {servicosStorage, servicoBensStorage} from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import {planosStorage} from "../../planos/shared/data.service";
import {PlanoNavigationService} from "../../planos/shared/plano-navigation.service";
import {PlanoService} from "../../planos/shared/plano.service";
import {ordensServicoItemsStorage} from "../../ordens-servico/shared/data.service";
import {OrdemServicoService} from "../../ordens-servico/shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../../ordens-servico/shared/ordem-servico-navigation.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";

@Injectable()
export class ServicoService {

    constructor(
        private _planoNavigationService: PlanoNavigationService,
        private _planoService: PlanoService,
        private _ordemServicoService: OrdemServicoService,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _frotaNavigationService: FrotaNavigationService,

        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(servicosStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(servicosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(servicosStorage + "-new");
    }

    setServicoBemSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(servicoBensStorage + '-new', object);
    }

    getServicoBemSessionStorage() {
        let item: string = sessionStorage.getItem(servicoBensStorage + "-new");
        return JSON.parse(item);
    }

    clearServicoBemSessionStorage() {
        sessionStorage.removeItem(servicoBensStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        let otherFormObject: any;
        if(Response) {
            if (otherForm === planosStorage) {
                otherFormObject = this._planoService.getSessionStorage();
                otherFormObject.servicoObject = Response;
                this._planoService.setSessionStorage(otherFormObject);
            } else if (otherForm === ordensServicoItemsStorage) {
                otherFormObject = this._ordemServicoService.getItemsSessionStorage();
                otherFormObject.servico = Response;
                this._ordemServicoService.setItemsSessionStorage(otherFormObject);
            } else if (otherForm === servicoBensStorage) {
                otherFormObject = this.getServicoBemSessionStorage();
                otherFormObject.servico = Response;
                this.setServicoBemSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(servicosStorage);

        if (otherForm === planosStorage) {
            otherFormObject = this._planoService.getSessionStorage();
            if (otherFormObject.id) {
                this._planoNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._planoNavigationService.goToNew();
            }
        } else if (otherForm === ordensServicoItemsStorage) {
            otherFormObject = this._ordemServicoService.getItemsSessionStorage();
            if (otherFormObject.id) {
                this._ordemServicoNavigationService.goToEditServico(otherFormObject.osId, otherFormObject.tipo, otherFormObject.id);
            } else {
                this._ordemServicoNavigationService.goToNewServico(otherFormObject.osId, otherFormObject.tipo);
            }
        } else if (otherForm === servicoBensStorage) {
            otherFormObject = this.getServicoBemSessionStorage();
            this._frotaNavigationService.goToFrotaPlanoManutencao(otherFormObject.moduleRouter);
        }
    }

    setServicosToModel(list: any[]) {
        setTimeout(function() {
            let x: any, lenX: any, id: any, text: any;
            for (x = 0, lenX = list.length; x < lenX; x++) {
                id = 'servico_' + x;
                if (list[x].servico) {
                    if (list[x].servico.descricao) {
                        text = list[x].servico.descricao;
                    } else {
                        text = list[x].servico.text;
                    }
                    list[x].servico.text = text;
                }

                this._autocompleteService.createOptionOnSelect2(id, list[x].servico);
                this._autocompleteService.setValueOnSelect2(list[x].servico.id, id);
            }
        }.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/shared/servico.service.ts
 **/